/**
 * The five scores a finished plan carries. Every one of them is stored on
 * `pog.metrics`, so a list of plans can be sorted and filtered by any of them
 * without opening the plans themselves.
 */
export const pogMetricNames = [
  "returnOnSpace",
  "coreRange",
  "shelfAlignment",
  "dosMos",
  "aesthetics",
] as const;

export type PogMetricName = (typeof pogMetricNames)[number];

export const isPogMetricName = (value: unknown): value is PogMetricName =>
  typeof value === "string" && (pogMetricNames as readonly string[]).includes(value);

/**
 * "Show me everything scoring below N on <metric>". Both params travel
 * together: one without the other is ignored, so a half-filled control never
 * silently drops rows. A plan with no score for that metric is never a match.
 */
export type MetricBelowFilterQueryParams = {
  metric_filter?: PogMetricName;
  metric_below?: number;
};
